export default function () {
  return {
    brands: [],
    loading: false,
  }
}
